import React from 'react';
import ClientContract from './ClientContract';
import ClientRouteTemplate from './ClientRouteTemplate';

const ClientContractRoute = (props) => (
  <ClientRouteTemplate 
    {...props}
    Component={ClientContract}
    componentName="Contrat"
  />
);

export default ClientContractRoute;
